import { Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Button, WhiteBox } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";

type ConsentGovernanceDisabledStateProps = {
    onOpenFeatureSwitches: () => void;
};

export const ConsentGovernanceDisabledState = ({ onOpenFeatureSwitches }: ConsentGovernanceDisabledStateProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <WhiteBox padding={theme.spacing(4)} boxShadow={theme.custom.shadows.grey}>
            <Stack gap={theme.spacing(2)} alignItems="flex-start">
                <Typography variant="h3" sx={{ fontSize: "20px", fontWeight: 700 }}>
                    {t("settings.consent.disabled.title", "Consent governance is disabled")}
                </Typography>
                <Typography variant="body" sx={{ color: theme.custom.grey[2000], maxWidth: "780px" }}>
                    {t(
                        "settings.consent.disabled.description",
                        "Activate the global feature switch to expose the user preference center, the contractual acceptance history, and the administration screens.",
                    )}
                </Typography>
                <Button variant="primary" onClick={onOpenFeatureSwitches}>
                    {t("settings.consent.disabled.open_features", "Go to feature switches")}
                </Button>
            </Stack>
        </WhiteBox>
    );
};
